import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../components/Loading";
import { useGetMatkaMarketsQuery } from "../services/matka/matkaApi";

const PAGE_SIZE = 20;

const statusBadge = (game) => {
  const map = {
    open:             { cls: "bg-green-100 text-green-700",  label: "Open" },
    closed:           { cls: "bg-red-100 text-red-700",     label: "Closed" },
    result_declared:  { cls: "bg-blue-100 text-blue-700",   label: "Result Declared" },
  };
  const s = map[game.status] || { cls: "bg-gray-100 text-gray-600", label: game.status || "-" };
  return (
    <span className={`px-2 py-0.5 text-xs rounded font-medium capitalize ${s.cls}`}>
      {s.label}
    </span>
  );
};

const MatkaBetPage = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const { data, isLoading, error, refetch } = useGetMatkaMarketsQuery({});

  const games = data?.data || [];
  const totalPages = Math.ceil(games.length / PAGE_SIZE);
  const paginated = games.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  return (
    <div className="w-full">
      <div className="bg-[#0F2327] px-5 py-3 flex items-center justify-between">
        <span className="text-white text-xl font-semibold">Matka Bets</span>
        <div className="flex gap-2">
          <button
            onClick={refetch}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-1.5 text-sm transition-colors"
          >
            Refresh
          </button>
          <button
            onClick={() => navigate(-1)}
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-1.5 text-sm transition-colors"
          >
            Back
          </button>
        </div>
      </div>

      {error && (
        <div className="mx-4 my-3 p-3 bg-red-100 text-red-700 border border-red-300 text-sm">
          {error?.data?.message || "Failed to load matka games"}
        </div>
      )}

      <div className="overflow-x-auto">
        {isLoading ? (
          <div className="flex justify-center py-16"><Loading /></div>
        ) : (
          <>
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr className="bg-[#0F2327] text-white">
                  <th className="px-4 py-3 text-left font-semibold border border-[#1a3a40]">#</th>
                  <th className="px-4 py-3 text-left font-semibold border border-[#1a3a40]">Name</th>
                  <th className="px-4 py-3 text-left font-semibold border border-[#1a3a40]">Status</th>
                  <th className="px-4 py-3 text-left font-semibold border border-[#1a3a40]">Bet Close</th>
                  <th className="px-4 py-3 text-left font-semibold border border-[#1a3a40]">Result Time</th>
                  <th className="px-4 py-3 text-left font-semibold border border-[#1a3a40]">Time Left</th>
                  <th className="px-4 py-3 text-left font-semibold border border-[#1a3a40]">Total Bets</th>
                  <th className="px-4 py-3 text-left font-semibold border border-[#1a3a40]">Total Stake</th>
                  <th className="px-4 py-3 text-left font-semibold border border-[#1a3a40]">Pending</th>
                  <th className="px-4 py-3 text-left font-semibold border border-[#1a3a40]">Last Result</th>
                  <th className="px-4 py-3 text-left font-semibold border border-[#1a3a40]">Action</th>
                </tr>
              </thead>
              <tbody>
                {paginated.length === 0 ? (
                  <tr>
                    <td colSpan={11} className="text-center py-12 text-gray-400 border border-gray-200">
                      No matka games found
                    </td>
                  </tr>
                ) : (
                  paginated.map((game, idx) => {
                    const r = game.lastResult;
                    const hasResult = r?.jodiNumber || r?.harufAndar || r?.harufBahar;
                    return (
                      <tr key={game.eventId} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                        <td className="px-4 py-2.5 border border-gray-200">{(currentPage - 1) * PAGE_SIZE + idx + 1}</td>
                        <td className="px-4 py-2.5 border border-gray-200 font-medium capitalize text-gray-800">{game.name}</td>
                        <td className="px-4 py-2.5 border border-gray-200">{statusBadge(game)}</td>
                        <td className="px-4 py-2.5 border border-gray-200">{game.betCloseTime || "-"}</td>
                        <td className="px-4 py-2.5 border border-gray-200">{game.resultTime || "-"}</td>
                        <td className="px-4 py-2.5 border border-gray-200 text-blue-600 font-medium">{game.timeRemainingLabel || "-"}</td>
                        <td className="px-4 py-2.5 border border-gray-200">{game.totalBets ?? 0}</td>
                        <td className="px-4 py-2.5 border border-gray-200">{game.totalStake ?? 0}</td>
                        <td className="px-4 py-2.5 border border-gray-200">
                          {game.pendingBets > 0 ? (
                            <span className="text-orange-600 font-medium">{game.pendingBets}</span>
                          ) : (
                            <span className="text-gray-400">0</span>
                          )}
                        </td>
                        <td className="px-4 py-2.5 border border-gray-200 text-xs">
                          {hasResult ? (
                            <div className="space-y-0.5">
                              {r.jodiNumber && <div><span className="text-gray-500">Jodi:</span> <span className="font-semibold text-gray-800">{r.jodiNumber}</span></div>}
                              {r.harufAndar && <div><span className="text-gray-500">Andar:</span> <span className="font-semibold text-gray-800">{r.harufAndar}</span></div>}
                              {r.harufBahar && <div><span className="text-gray-500">Bahar:</span> <span className="font-semibold text-gray-800">{r.harufBahar}</span></div>}
                            </div>
                          ) : (
                            <span className="text-gray-400">-</span>
                          )}
                        </td>
                        <td className="px-4 py-2.5 border border-gray-200">
                          <button
                            onClick={() => navigate(`/matka/all-bets/${game.eventId}/${encodeURIComponent(game.name)}`)}
                            className="bg-[#0F2327] hover:bg-[#1a3a40] text-white px-3 py-1.5 text-xs font-medium transition-colors rounded-sm"
                          >
                            View Bets
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>

            {totalPages > 1 && (
              <div className="flex justify-end items-center gap-1 px-4 py-3 border-t border-gray-200 bg-white">
                <button
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-500 disabled:opacity-40 hover:bg-gray-50 text-sm"
                >
                  ‹
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                  <button
                    key={p}
                    onClick={() => setCurrentPage(p)}
                    className={`w-8 h-8 flex items-center justify-center border text-sm font-medium ${
                      currentPage === p
                        ? "border-blue-500 bg-blue-500 text-white"
                        : "border-gray-300 text-gray-600 hover:bg-gray-50"
                    }`}
                  >
                    {p}
                  </button>
                ))}
                <button
                  onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                  className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-500 disabled:opacity-40 hover:bg-gray-50 text-sm"
                >
                  ›
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MatkaBetPage;
